import React from 'react';
import { BD } from '../bookDemoTheme';

interface TextFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: 'text' | 'email' | 'tel';
  autoComplete?: string;
  error?: string;
  onBlur?: () => void;
}

const TextField: React.FC<TextFieldProps> = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  type = 'text',
  autoComplete,
  error,
  onBlur,
}) => (
  <div>
    <label htmlFor={id} className={`block text-[14px] leading-[18px] font-medium mb-3 ${BD.textPrimary}`}>
      {label}
    </label>
    <input
      id={id}
      type={type}
      value={value}
      autoComplete={autoComplete}
      onChange={e => onChange(e.target.value)}
      onBlur={onBlur}
      placeholder={placeholder}
      aria-invalid={error ? true : undefined}
      className={`w-full h-11 rounded-lg border px-[13px] text-[14px] leading-5 focus:outline-none ${BD.inputShadow} ${
        BD.inputBg
      } ${error ? BD.errorBorder : BD.border} ${BD.textPrimary} ${BD.placeholder}`}
    />
    {error && <p className={`mt-2 text-[13px] leading-5 ${BD.errorText}`}>{error}</p>}
  </div>
);

export default TextField;
